import { useWebSocket } from '@/context/websocketContext';
import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppEventBusContext } from '@/context/eventBusContext';
import { SubscribeEvent } from '@/interface/event';
import { useTradeStore } from '../store';

export const useWsTokenKline = () => {
  const { address } = useParams();
  const { data: wsData, isConnected, sendMessage } = useWebSocket();
  const { publish } = useAppEventBusContext();
  const { setTokenRealtimePrice, klinePeriod } = useTradeStore();

  const subscribeToWebSocket = useCallback(() => {
    if (isConnected && address) {
      const params = { tokenAddress: address, timeframe: klinePeriod };
      sendMessage('subscribeToken', params);
      return () => sendMessage('unsubscribeToken', params);
    }
  }, [isConnected, address, klinePeriod]);

  const handleWebSocketUpdate = useCallback(() => {
    if (!wsData?.data) return;

    if (wsData.event === 'klineUpdate') {
      const latestPrice = wsData.data.close;
      publish(SubscribeEvent.Update_Realtime_Price, wsData.data);
      setTokenRealtimePrice(latestPrice.toString());
    }
  }, [isConnected, wsData]);

  useEffect(subscribeToWebSocket, [isConnected, address, klinePeriod]);
  useEffect(handleWebSocketUpdate, [isConnected, wsData, klinePeriod]);
};
